import { createSlice } from '@reduxjs/toolkit';

const appointmentSlice = createSlice({
  name: 'appointment',
  initialState: {
    updatingAppointment: null,
    dropOffAppointment: {},
    pickupFinishAppointment: {},
    confirmationScreenType: null,
    isPickupFinishClicked: false,
  },
  reducers: {
    setDropOffAppointment: (state, action) => {
      state.dropOffAppointment = action.payload;
    },
    setPickupFinishAppointment: (state, action) => {
      state.pickupFinishAppointment = action.payload;
    },
    setConfirmationScreenType: (state, action) => {
      state.confirmationScreenType = action.payload;
    },
    setAppointmentUpdating: (state, action) => {
      state.updatingAppointment = action.payload;
    },
    setPickupFinishClicked: (state) => {
      state.isPickupFinishClicked = true;
    },
    setPickupFinishUnclicked: (state) => {
      state.isPickupFinishClicked = false;
    },
  },
});

export const {
  setDropOffAppointment,
  setPickupFinishAppointment,
  setConfirmationScreenType,
  setAppointmentUpdating,
  setPickupFinishClicked,
  setPickupFinishUnclicked,
} = appointmentSlice.actions;
export default appointmentSlice.reducer;
